define(["marionette", "jquery", "./template/engineKbModalTemplate.html"], function (
  Marionette,
  $,
  EngineKbModalTemplate,
) {
  "use strict";

  const EngineKbModalView = {};

  EngineKbModalView.view = Marionette.ItemView.extend({
    template: EngineKbModalTemplate,
    modelEvents: {
      "change:kbs": "updateKbData",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
    ui: {
      doneButton: "#doneButton",
      engine: "#engine",
      engineError: "#engineError",
      kb: "#kb",
      kbError: "#kbError",
    },
    onRender: function () {
      this.constructor.__super__.onRender.call(this);
      this._createEngineSelect();
      this._createKbSelect();
    },
    _createEngineSelect: function () {
      this.ui.engine
        .select2({
          data: [
            {
              id: 0,
              text: "",
            },
          ].concat(
            this.model.get("engines").map((engine) => {
              return {
                id: engine.get("engineId"),
                text: engine.get("engineName"),
              };
            }),
          ),
          placeholder: {
            id: 0,
            text: $.t("admin.engineAdmin.enginePlaceholder"),
          },
          width: "80%",
        })
        .on("select2:select", (e) => {
          this.trigger("engine:select", e.params.data);
        });
    },
    _createKbSelect: function () {
      this.ui.kb
        .select2({
          data: [
            {
              id: 0,
              text: "",
            },
          ].concat(
            this.model.get("kbs").map((kb) => {
              return {
                id: kb.get("kbId"),
                text: kb.get("kbName"),
              };
            }),
          ),
          placeholder: {
            id: 0,
            text: $.t("admin.engineAdmin.kbPlaceholder"),
          },
          width: "80%",
        })
        .on("select2:select", (e) => {
          this.trigger("kb:select", e.params.data);
        });
    },
    clearErrors: function () {
      this.$el.find("h5.error-message").remove();
    },
    disableDoneButton: function () {
      this.ui.doneButton.prop("disabled", true);
    },
    disableKb: function () {
      this.ui.kb.prop("disabled", true);
    },
    enableDoneButton: function () {
      this.ui.doneButton.prop("disabled", false);
    },
    enableKb: function () {
      this.ui.kb.prop("disabled", false);
    },
    showEngineError: function (errorMessage) {
      this.ui.engineError
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    showKbError: function (errorMessage) {
      this.ui.kbError
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    updateKbData: function () {
      this.ui.kb.select2("destroy");
      this._createKbSelect();
    },
  });

  return EngineKbModalView;
});
